import { Theme } from '@mui/material'

const classes = {
  label: {
    lineHeight: 1,
  },
  ppmLabel: {
    display: 'block',
    lineHeight: 1,
  },
  ammWarningLabel: {
    textAlign: 'center',
    lineHeight: 1,
  },
  textValueContainer: {
    alignItems: 'center',
    gap: 0.2,
  },
  statusItemWarningIcon: (theme: Theme) => ({
    fontSize: 18,
    color: theme.palette.warning.light,
  }),
}

export default classes
